import { colors, fonts, sizes } from '../../theme';

const styles = {
  paperProps: {
    sx: {
      width: sizes.drawer,
      maxWidth: '100vw',
      backgroundColor: colors.surface,
      backgroundImage: 'none',
      borderLeft: `1px solid ${colors.border}`,
      color: colors.text,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  backdropProps: {
    transitionDuration: 120,
    sx: {
      backgroundColor: colors.overlay,
    },
  },
  // The drawer below already darkens the page; a click outside still closes.
  backdropPropsStacked: {
    transitionDuration: 120,
    sx: {
      backgroundColor: 'transparent',
    },
  },
  // Quick: the player inside looks half drawn while the drawer slides in.
  transitionDuration: {
    enter: 120,
    exit: 120,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    minHeight: sizes.topBar,
    pl: 2.5,
    pr: 1.5,
    borderBottom: `1px solid ${colors.border}`,
    flexShrink: 0,
    boxSizing: 'border-box',
  },
  headerPlain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    pl: 2.5,
    pr: 1.5,
    pt: 2.5,
    pb: 0.5,
    flexShrink: 0,
    boxSizing: 'border-box',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  },
  title: {
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 700,
    color: colors.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  // Only the body scrolls: the footer actions stay pinned at the bottom.
  body: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  bodyPlain: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    px: 2.5,
    pt: 1.5,
    pb: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  footer: {
    flexShrink: 0,
    px: 2.5,
    py: 2,
    display: 'grid',
    gridAutoColumns: 'minmax(0, 1fr)',
    gridAutoFlow: 'column',
    gap: 1,
    borderTop: `1px solid ${colors.border}`,
    backgroundColor: colors.surface,
  },
};

export default styles;
